import { useTranslation } from 'libs/i18n';
import { DocumentsTableFeature } from 'modules/client/common/feature';

export const CompanyConstituentDocumentsSection = () => {
  const { t } = useTranslation();

  return (
    <DocumentsTableFeature
      name="constituentDocsFiles"
      title={t('client.legal.companyConstituentDocuments.title')}
      titleVariant="subtitle"
    />
  );
};
